import { FC } from 'react';

import { useAudienceNameConfiguration } from './hooks';

const Name: FC = () => {
  const { component } = useAudienceNameConfiguration();

  return <>{component}</>;
};

export default Name;
